export default __webpack_public_path__ + "static/media/praia-fluvial-vale-de-juncal.f16c5bcc.jpg";